import React, { useEffect } from "react";
import styled, { withTheme } from "styled-components";
import { makeStyles } from "@mui/styles";
import { withStyles } from "@mui/styles";
import { spacing } from "@mui/system";
import {
  Box,
  Button as MuiButton,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Paper,
  Select as MuiSelect,
  TextField as MuiTextField,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import { put, post } from "../api/actions";
import { setSnackbar } from "../../snackbar/api/snackbar";
import { isNotEmpty } from "../../../utils/Utils";
import { getByUuid as getProperty } from "../api/actions"
import { get as getProperties } from "../api/actions"
import { getById as getPropertyManager } from "modules/propertyManager/api/actions";
import StatusTag from "modules/apl/components/StatusTag";
import { useNavigate } from "react-router-dom";


const TextField = styled(MuiTextField)(spacing);
const Select = styled(MuiSelect)(spacing);

const PropertyForm = (props) => {
  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    loadingIcon: {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
    },
  }));

  const dispatch = useDispatch();

  const [property, setProperty] = React.useState({});
  const [submitted, setSubmitted] = React.useState(false);

  const [isRemote, setIsRemote] = React.useState(false);
  const [isPmTenantFinal, setIsPmTenantFinal] = React.useState(false);
  const [isPmMax, setIsPmMax] = React.useState(false);

  const toggleIsRemote = () => {
    const newIsRemote = !isRemote;
    setIsRemote(newIsRemote);
    setProperty(prevProperty => ({
      ...prevProperty,
      isRemote: newIsRemote ? 1 : 0
    }));
  };
  const toggleIsPmTenantFinal = () => {
    const newIsPmTenantFinal = !isPmTenantFinal;
    setIsPmTenantFinal(newIsPmTenantFinal);
    setProperty(prevProperty => ({
      ...prevProperty,
      pmTenantFinal: newIsPmTenantFinal ? 1 : 0
    }));
  };
  const toggleIsPmMax = () => {
    const newIsPmMax = !isPmMax;
    setIsPmMax(newIsPmMax);
    setProperty(prevProperty => ({
      ...prevProperty,
      pmMax: newIsPmMax ? 1 : 0
    }));
  };

  const navigate = useNavigate()

  // Reset form
  const resetFormValues = () => {
    if (props.properties.data.property && props.properties.data.property.id) {
      // edit property
      setProperty(props.properties.data.property);
      setIsRemote(props.properties.data.property.isRemote === 1);
      setIsPmTenantFinal(props.properties.data.property.pmTenantFinal === 1);
      setIsPmMax(props.properties.data.property.pmMax === 1);
    } else if (props.properties.data.property && Object.keys(props.properties.data.property).length === 0) {
      // create new property
      setProperty({});
      setIsRemote(false);
      setIsPmTenantFinal(false);
      setIsPmMax(false);
    }
  };

  useEffect(() => {
    resetFormValues();
  }, [props.properties.data.property]);

  const onFieldChange = (e) => {
    if (submitted) setSubmitted(false);
    const name = e?.target?.name ?? e?.name;
    const value = e?.target?.value ?? e?.value;
    setProperty(prevProperty => {
      const currProperty = prevProperty || {};
      return {
        ...currProperty,
        [name]: value
      };
    });
  };

  function checkEmpty(value) {
    return (value != null && value != "");
  }

  useEffect(() => {
    if (props.properties.newlyAddedProperty != null) {
      window.open(
        "/property/" + props.properties.newlyAddedProperty.uuid + "/" + props.properties.newlyAddedProperty.id + "/" + props.properties.newlyAddedProperty.propertyManagerId
      );
    }
  }, [props.properties.newlyAddedProperty]);


  const validate = () => {
    var newProperty = {
      name: property.name ? property.name : "",
      developerId: property.developerId ? property.developerId : "",
      address: property.address ? property.address : "",
      isRemote: property.isRemote ? property.isRemote : 0,
      pmTenantFinal: property.pmTenantFinal ? property.pmTenantFinal : 0,
      pmMax: property.pmMax ? property.pmMax : 0,

      ownerId: property.ownerId ? property.ownerId : "",
      propertyManagerId: property.propertyManagerId
        ? property.propertyManagerId
        : "",
      city: property.city ? property.city : "",
      state: property.state ? property.state : "",
      zip: property.zip ? property.zip : "",
      statusId: property.statusId ? property.statusId : "",
    };

    const values = [];
    Object.keys(newProperty).forEach(function (key) {
      let val = newProperty[key];
      if (key != "isRemote" && key != "pmTenantFinal" && key != "pmMax") {
        values.push(val);
      }
    });

    newProperty.id = property.id;
    newProperty.uuid = property.uuid;

    setProperty(newProperty);

    if (values.every(checkEmpty)) {
      return newProperty;
    } else {
      return -1;
    }
  };

  const save = async () => {
    const newProperty = validate();
    console.log(newProperty)
    if (newProperty == -1) {
      setSubmitted(true);
      return;
    }

    if (!newProperty.id) {
      props.post(newProperty).then(() => {
        props.onUpdate();
        props.getProperties();
      });
    }
    else {
      //console.log(newProperty)
      props.onUpdate();
      await props.put(newProperty);
      navigate(`/property/${newProperty?.uuid}/${newProperty?.id}/${newProperty?.propertyManagerId}`);
      await props.getProperty(property.uuid)
      await props.getPropertyManager(property.propertyManagerId)
    }

  };

  const classes = useStyles();

  if (
    !property ||
    props.propertyIsLoading ||
    props.developers.isLoading ||
    props.propertyManagers.isLoading ||
    props.propertyStatuses.isLoading ||
    props.properties.isLoading
  ) {
    return (
      <Card mb={6}>
        <CardContent>
          {/* TODO loading bars */}
          <Typography variant="h3" gutterBottom>
            Loading...
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Box sx={{ maxHeight: '80vh', overflow: 'auto' }}>
      <Card elevation={0}>
        <CardContent sx={{ p: 0 }}>
          {/* Basic Information Section */}
          <Paper sx={{ p: 3, mb: 3, backgroundColor: 'grey.50' }}>
            <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
              Basic Information
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <TextField
                label="Property Name *"
                type="text"
                value={property.name || ""}
                required
                onChange={onFieldChange}
                name="name"
                fullWidth
                variant="outlined"
                error={property["name"] == "" && submitted}
                helperText={property["name"] == "" && submitted ? "Property name is required" : ""}
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '1rem',
                    padding: '16px 14px',
                    minHeight: '24px',
                    lineHeight: '1.4375em'
                  },
                  '& .MuiInputBase-root': {
                    minHeight: '56px'
                  }
                }}
              />
            </Box>
          </Paper>

          {/* Address Information Section */}
          <Paper sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
              Address Information
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <TextField
                label="Street Address *"
                type="text"
                value={property.address || ""}
                required
                onChange={onFieldChange}
                name="address"
                fullWidth
                variant="outlined"
                error={property["address"] == "" && submitted}
                helperText={property["address"] == "" && submitted ? "Address is required" : ""}
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '1rem',
                    padding: '16px 14px',
                    minHeight: '24px',
                    lineHeight: '1.4375em'
                  },
                  '& .MuiInputBase-root': {
                    minHeight: '56px'
                  }
                }}
              />
              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  label="City *"
                  type="text"
                  onChange={onFieldChange}
                  value={property.city || ""}
                  name="city"
                  fullWidth
                  variant="outlined"
                  error={property["city"] == "" && submitted}
                  helperText={property["city"] == "" && submitted ? "City is required" : ""}
                  sx={{
                    '& .MuiInputBase-input': {
                      fontSize: '1rem',
                      padding: '16px 14px',
                      minHeight: '24px',
                      lineHeight: '1.4375em'
                    },
                    '& .MuiInputBase-root': {
                      minHeight: '56px'
                    }
                  }}
                />
                <TextField
                  label="State *"
                  type="text"
                  onChange={onFieldChange}
                  value={property.state || ""}
                  name="state"
                  fullWidth
                  variant="outlined"
                  error={property["state"] == "" && submitted}
                  helperText={property["state"] == "" && submitted ? "State is required" : ""}
                  sx={{
                    '& .MuiInputBase-input': {
                      fontSize: '1rem',
                      padding: '16px 14px',
                      minHeight: '24px',
                      lineHeight: '1.4375em'
                    },
                    '& .MuiInputBase-root': {
                      minHeight: '56px'
                    }
                  }}
                />
                <TextField
                  label="ZIP Code *"
                  type="text"
                  onChange={onFieldChange}
                  value={property.zip || ""}
                  name="zip"
                  fullWidth
                  variant="outlined"
                  error={property["zip"] == "" && submitted}
                  helperText={property["zip"] == "" && submitted ? "ZIP code is required" : ""}
                  sx={{
                    '& .MuiInputBase-input': {
                      fontSize: '1rem',
                      padding: '16px 14px',
                      minHeight: '24px',
                      lineHeight: '1.4375em'
                    },
                    '& .MuiInputBase-root': {
                      minHeight: '56px'
                    }
                  }}
                />
              </Box>
            </Box>
          </Paper>

          {/* Management & Ownership Section */}
          <Paper sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
              Management & Ownership
            </Typography>
            <Box sx={{ display: "flex",  gap: 2 }}>
              <FormControl fullWidth variant="outlined" sx={{
                '& .MuiInputBase-input': {
                  fontSize: '1rem',
                  padding: '16px 14px',
                  minHeight: '24px',
                  lineHeight: '1.4375em'
                },
                '& .MuiSelect-select': {
                  fontSize: '1rem',
                  padding: '16px 14px',
                  minHeight: '24px',
                  lineHeight: '1.4375em'
                },
                '& .MuiInputBase-root': {
                  minHeight: '56px'
                }
              }}>
                <InputLabel id="developer-select-label">
                  Developer *
                </InputLabel>
                <Select
                  labelId="developer-select-label"
                  id="developer-select"
                  value={property.developerId || ""}
                  onChange={onFieldChange}
                  name="developerId"
                  label="Developer *"
                  error={property["developerId"] == "" && submitted}
                >
                  {(props.developers.data.developersList?.items || []).map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth variant="outlined" sx={{
                '& .MuiInputBase-input': {
                  fontSize: '1rem',
                  padding: '16px 14px',
                  minHeight: '24px',
                  lineHeight: '1.4375em'
                },
                '& .MuiSelect-select': {
                  fontSize: '1rem',
                  padding: '16px 14px',
                  minHeight: '24px',
                  lineHeight: '1.4375em'
                },
                '& .MuiInputBase-root': {
                  minHeight: '56px'
                }
              }}>
                <InputLabel id="owner-select-label">
                  Owner *
                </InputLabel>
                <Select
                  labelId="owner-select-label"
                  id="owner-select"
                  value={property.ownerId || ""}
                  onChange={onFieldChange}
                  name="ownerId"
                  label="Owner *"
                  error={property["ownerId"] == "" && submitted}
                >
                  {(props.owners.data.ownersList?.items || []).map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth variant="outlined" sx={{
                '& .MuiInputBase-input': {
                  fontSize: '1rem',
                  padding: '16px 14px',
                  minHeight: '24px',
                  lineHeight: '1.4375em'
                },
                '& .MuiSelect-select': {
                  fontSize: '1rem',
                  padding: '16px 14px',
                  minHeight: '24px',
                  lineHeight: '1.4375em'
                },
                '& .MuiInputBase-root': {
                  minHeight: '56px'
                }
              }}>
                <InputLabel id="property-manager-select-label">
                  Property Manager *
                </InputLabel>
                <Select
                  labelId="property-manager-select-label"
                  id="property-manager-select"
                  value={property.propertyManagerId || ""}
                  onChange={onFieldChange}
                  name="propertyManagerId"
                  label="Property Manager *"
                  error={property["propertyManagerId"] == "" && submitted}
                >
                  {(props.propertyManagers.data.propertyManagersList?.items || []).map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                        <Typography variant="body1" sx={{ flexGrow: 1 }}>
                          {item.name}
                        </Typography>
                        {item.developerId && (
                          <StatusTag
                            type={"Default"}
                            label={"Developer"}
                          />
                        )}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth variant="outlined" sx={{
                '& .MuiInputBase-input': {
                  fontSize: '1rem',
                  padding: '16px 14px',
                  minHeight: '24px',
                  lineHeight: '1.4375em'
                },
                '& .MuiSelect-select': {
                  fontSize: '1rem',
                  padding: '16px 14px',
                  minHeight: '24px',
                  lineHeight: '1.4375em'
                },
                '& .MuiInputBase-root': {
                  minHeight: '56px'
                }
              }}>
                <InputLabel id="property-status-select-label">
                  Property Status
                </InputLabel>
                <Select
                  labelId="property-status-select-label"
                  id="property-status-select"
                  value={property.statusId || ""}
                  onChange={onFieldChange}
                  name="statusId"
                  label="Property Status"
                >
                  {(props.propertyStatuses.data.propertyStatusesList?.items || []).map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Paper>

          {/* Property Configuration Section */}
          <Paper sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
              Property Configuration
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
              <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)', md: '1 1 calc(33.33% - 12px)' } }}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isRemote}
                        onChange={toggleIsRemote}
                        name="isRemote"
                        color="primary"
                      />
                    }
                    label={
                      <Typography variant="body2" fontWeight={500}>
                        Remote Property
                      </Typography>
                    }
                  />
                </FormGroup>
              </Box>
              <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)', md: '1 1 calc(33.33% - 12px)' } }}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPmTenantFinal}
                        onChange={toggleIsPmTenantFinal}
                        name="pmTenantFinal"
                        color="primary"
                      />
                    }
                    label={
                      <Typography variant="body2" fontWeight={500}>
                        PM Owes Tenant Finals
                      </Typography>
                    }
                  />
                </FormGroup>
              </Box>
              <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)', md: '1 1 calc(33.33% - 12px)' } }}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPmMax}
                        onChange={toggleIsPmMax}
                        name="pmMax"
                        color="primary"
                      />
                    }
                    label={
                      <Typography variant="body2" fontWeight={500}>
                        $300 PM Maximum
                      </Typography>
                    }
                  />
                </FormGroup>
              </Box>
            </Box>
          </Paper>

          {/* Property Metrics Section */}
          <Paper sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
              Property Metrics
            </Typography>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                label="Total Units"
                type="number"
                value={property.totalUnits || ""}
                onChange={onFieldChange}
                name="totalUnits"
                fullWidth
                variant="outlined"
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '1rem',
                    padding: '16px 14px',
                    minHeight: '24px',
                    lineHeight: '1.4375em'
                  },
                  '& .MuiInputBase-root': {
                    minHeight: '56px'
                  }
                }}
              />
              <TextField
                label="Total Square Footage"
                type="number"
                value={property.totalSqFt || ""}
                onChange={onFieldChange}
                name="totalSqFt"
                fullWidth
                variant="outlined"
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '1rem',
                    padding: '16px 14px',
                    minHeight: '24px',
                    lineHeight: '1.4375em'
                  },
                  '& .MuiInputBase-root': {
                    minHeight: '56px'
                  }
                }}
              />
            </Box>
          </Paper>

          {/* Action Buttons */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, pt: 2, borderTop: '1px solid', borderColor: 'divider' }}>
            <MuiButton
              variant="outlined"
              onClick={props.onCancel}
              size="large"
            >
              Cancel
            </MuiButton>
            <MuiButton
              variant="contained"
              onClick={save}
              size="large"
              color="primary"
            >
              Save Property
            </MuiButton>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

// Component Properties
PropertyForm.propTypes = {
  apl: PropTypes.object.isRequired,
  propertyManagers: PropTypes.object.isRequired,
  developers: PropTypes.object.isRequired,
  propertyStatuses: PropTypes.object.isRequired,
  put: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
  owners: PropTypes.object.isRequired,
  properties: PropTypes.object.isRequired,
  property: PropTypes.func.isRequired,
  getPropertyManager: PropTypes.func.isRequired,
  getProperties: PropTypes.func.isRequired
};

function PropertyFormState(state) {
  return {
    apl: state.apl,
    propertyManagers: state.propertyManagers,
    developers: state.developers,
    owners: state.owners,
    propertyStatuses: state.propertyStatuses,
    properties: state.properties,
  };
}
export default connect(PropertyFormState, { put, post, getProperty, getPropertyManager, getProperties })(PropertyForm);
